import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesProcessingJob = {
  job: '',
  state: undefined,
  startedAtFrom: null,
  startedAtTo: null,
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageProcessingJob = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesProcessingJob}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageProcessingJob.displayName = 'Page processing job initializer component';

export default PageProcessingJob;
